import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../analytics/matomo'

const MatomoRouteTracker = () => {
  const location = useLocation()

  useEffect(() => {
    const url =
      `${window.location.origin}${location.pathname}${location.search}${location.hash}`

    trackPageView(url)
  }, [location.pathname, location.search, location.hash])

  return null
}

export default MatomoRouteTracker